import { render, staticRenderFns } from "./fontamount-flow-statistical-list.vue?vue&type=template&id=220e4000&scoped=true&"
import script from "./fontamount-flow-statistical-list.vue?vue&type=script&lang=ts&"
export * from "./fontamount-flow-statistical-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e4000",
  null
  
)

export default component.exports